/**
 * Remark plugin that sanitises raw HTML in Markdown AST nodes.
 * - `<br>` tags are converted to MDAST `break` nodes.
 * - All other raw HTML is downgraded to plain text so it doesn't render as HTML.
 */

/** Inline HTML tags that are safe to pass through to rehype-raw for rendering. */
const INLINE_HTML_TAGS = /^<\/?(sub|sup|mark|small|abbr|ins|del|br)\b/i;

export function remarkBrOnly() {
	return (tree: any) => {
		const visit = (node: any) => {
			if (!node || typeof node !== 'object') return;

			const children: any[] | undefined = node.children;
			if (Array.isArray(children)) {
				for (let i = 0; i < children.length; i++) {
					const child = children[i];
					if (
						child?.type === 'html' &&
						typeof child.value === 'string'
					) {
						if (/^\s*<br\s*\/?>\s*$/i.test(child.value)) {
							children[i] = { type: 'break' };
						} else if (INLINE_HTML_TAGS.test(child.value.trim())) {
							// Preserve inline HTML for rehype-raw to render
						} else {
							children[i] = { type: 'text', value: child.value };
						}
						continue;
					}
					visit(child);
				}
			}
		};

		visit(tree);
	};
}
